module.exports = __webpack_public_path__ + "static/media/2.1164a803.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HIFEM/Images/2.png
// module id = 701
// module chunks = 0